export default "__VITE_ASSET__DBnBetv3__"